import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessProductSubcategoryModifierListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-product-subcategory-modifier-list',
  templateUrl: 'business-product-subcategory-modifier-list.html',
})
export class BusinessProductSubcategoryModifierListPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessProductSubcategoryModifierListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-subcategory-modifier-list/business-product-subcategory-modifier-list.ts